var _rect, _rect2, _circle, _path, _path2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162 204",
    className: "jfWizard-list-item-icon-svg",
    width: 120,
    height: 147,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 204,
    rx: 4,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 144,
    height: 46,
    rx: 4,
    fill: "#09F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 28,
    r: 11,
    fill: "#FFB629"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.7 22.39L85 55h64l-28.871-32.544a3 3 0 00-4.429-.066z",
    fill: "#9EDC36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.754 29.875L66 55h50.5L94.174 29.94a3 3 0 00-4.42-.065z",
    fill: "#78BB07"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 90,
    width: 144,
    height: 14,
    rx: 7,
    fill: "#C8C8E3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 137,
    width: 144,
    height: 14,
    rx: 7,
    fill: "#C8C8E3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 67,
    width: 68,
    height: 14,
    rx: 7,
    fill: "#E6E6F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 114,
    width: 68,
    height: 14,
    rx: 7,
    fill: "#E6E6F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneForm);
export default __webpack_public_path__ + "static/media/oneForm.1dff6a03.svg";
export { ForwardRef as ReactComponent };